import { useState } from 'react';

export const FULL_REPO_PATH = '/';

const usePaths = (defaultPaths = []) => {
  const [paths, setPaths] = useState(defaultPaths); //key, values -> {1234: ['myfolder', 'hisfolder']}

  const getRepoPathsByRepoId = repoId =>
    paths.find(({ repository_id }) => repository_id === repoId);

  const repoFullPathConfirmation = repo => {
    if (repo.paths.length > 0) {
      return window.confirm(
        'Entering slash will replace all paths with the entire repository. Proceed?'
      );
    }
    return true;
  };

  const removeRepoPaths = repoId => {
    const updatedRepoPaths = paths.filter(
      ({ repository_id }) => repository_id !== repoId
    );
    setPaths(updatedRepoPaths);
  };

  const updateExistedRepoPaths = updatedRepo => {
    const updatedReposPaths = paths.map(repoPaths =>
      repoPaths.repository_id === updatedRepo.repository_id
        ? updatedRepo
        : repoPaths
    );
    setPaths(updatedReposPaths);
  };

  const insertFolder = (repoId, newFolder) => {
    const createNewRepo = () => ({
      repository_id: repoId,
      paths: []
    });
    const existedRepo = getRepoPathsByRepoId(repoId);
    const currRepo = existedRepo || createNewRepo();

    const isFullRepoPath = newFolder === FULL_REPO_PATH;
    if (isFullRepoPath) {
      if (!repoFullPathConfirmation(currRepo)) return;
    }

    currRepo.paths = isFullRepoPath
      ? [FULL_REPO_PATH]
      : [newFolder, ...currRepo.paths.filter(path => path !== FULL_REPO_PATH)];
    if (!existedRepo) {
      setPaths([...paths, currRepo]);
    } else {
      updateExistedRepoPaths(currRepo);
    }
  };
  const removeFolder = (repoId, folder) => {
    const currRepo = getRepoPathsByRepoId(repoId);
    currRepo.paths = currRepo?.paths?.filter(path => path !== folder) || [];
    if (currRepo.paths.length) {
      updateExistedRepoPaths(currRepo);
    } else {
      removeRepoPaths(repoId);
    }
  };
  const editFolder = (repoId, oldFolder, newFolder) => {
    const isFullRepoPath = newFolder === FULL_REPO_PATH;
    const currRepo = getRepoPathsByRepoId(repoId);

    if (isFullRepoPath) {
      if (!repoFullPathConfirmation(currRepo)) return;
    }

    currRepo.paths = isFullRepoPath
      ? [FULL_REPO_PATH]
      : currRepo.paths.map(folder =>
          folder === oldFolder ? newFolder : folder
        );
    updateExistedRepoPaths(currRepo);
  };

  return {
    paths,
    insertFolder,
    removeFolder,
    editFolder
  };
};

export default usePaths;
